module.exports = __webpack_public_path__ + "static/media/crying-emoji-emoticon-emotion-expression-sad-svgrepo-com.ebcdb97c.svg";